import React, { useEffect, useState } from 'react';
import { setAccessRestrictedHandler } from '../services/api';
import './UnauthorizedScreen.css';

/**
 * Top-level gate that listens for 423 `access_restricted` API responses (a
 * temporary fraud ban set from the admin panel) and shows a full-screen
 * "Доступ ограничен" message. The ban can only be lifted from the admin panel,
 * so there is no retry action — once shown it stays until the app is reopened.
 *
 * Must be mounted once, above the app shell, so it also covers the very first
 * `GET /api/auth/verify` on startup (which returns 423 before auth resolves).
 */
export const AccessRestrictedGate: React.FC = () => {
  const [isRestricted, setIsRestricted] = useState(false);

  useEffect(() => {
    setAccessRestrictedHandler(() => setIsRestricted(true));
    return () => {
      setAccessRestrictedHandler(null);
    };
  }, []);

  if (!isRestricted) {
    return null;
  }

  return (
    <div
      className="unauthorized-screen"
      style={{ position: 'fixed', inset: 0, zIndex: 10002 }}
      role="alert"
    >
      <div className="unauthorized-content" style={{ background: 'none', boxShadow: 'none' }}>
        <h1 className="unauthorized-title">Доступ ограничен</h1>
      </div>
    </div>
  );
};
